(function initForm () {
  const params = new URLSearchParams(window.location.search)
  params.forEach((value, key) => {
    document.querySelector('#reset_customer input[name="'+ key +'"]').value = value
  })
})()

const buttonReset = document.querySelector('#reset-btn')
buttonReset.addEventListener('click', function (e) {
    const errorMsgNode = $('.recover-error-msg')
    const resetFormNode = $('#reset_customer')
    
    const passVal = resetFormNode.find('input[name="password"]').val()
    const passConfirmationVal = resetFormNode.find('input[name="password_confirmation"]').val()

    if (passVal.length < 8 || passVal.length > 20) {
      errorMsgNode.find('.errors').html('<li>パスワードは8～20文字で入力してください。</li>')
      errorMsgNode.addClass('form__message-error')
      return
    }

    if (passVal != passConfirmationVal) {
      errorMsgNode.find('.errors').html('<li>確認用パスワードは、入力したパスワードと一致している必要があります</li>')
      errorMsgNode.addClass('form__message-error')
      return
    }

    $(e.target).attr('disabled', true)

    errorMsgNode.removeClass('form__message-error form__message-success form__message-server')

    const formData = new URLSearchParams();
    $('#reset_customer').serializeArray().forEach(item => {
      if (item.name != 'password_confirmation') {
        formData.append(item.name, item.value);
      }
    })

    fetch('/a/account/reset', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: formData
    })
    .then(response => response.json())
    .then(async (data) => {
      if (data.code === 0) {
        const parts = data.data.redirect_url.split('/')
        const token = parts[parts.length - 1]
        
        try {
          await window.ShopifyConstant.getMt_t(token, 'Reset Failed')
          errorMsgNode.addClass('form__message-success')
          if (window.location.hostname == '127.0.0.1') {
            window.location.href = `http://127.0.0.1:9292/account/login/multipass/${token}`
            return
          }
          window.location.href = data.data.redirect_url
          return
        } catch (error) {
          data.msg = error
        }
      }
    
      let errorHtml = ''
      if (data.msg && typeof data.msg == 'object') {
        for (const key in data.msg) {
          errorHtml += `<li>${data.msg[key]}</li>`
        }
      } else {
        errorHtml += `<li>${data.msg}</li>`
      }

      errorMsgNode.find('.errors').html(errorHtml)
      errorMsgNode.addClass('form__message-error')

      $(e.target).attr('disabled', false)
    })
    .catch(error => {
      errorMsgNode.addClass('form__message-error form__message-server')
      $(e.target).attr('disabled', false)
    });
})